module.exports = __webpack_public_path__ + "static/colaboradores-01-455fb91c6b7308440bbb2bc9f6b08b3b.png";